import { type AdvancingActivitySource } from "advancing/activity/AdvancingActivityLog";

export const getApproveActivitySource = (advancingSessionId: number): AdvancingActivitySource => ({
  queryKey: ["AdvancingSession.ListActivity", advancingSessionId],
  fetchPage: (page, perPage) => window.CoreApi.AdvancingSession.ListActivity({ advancingSessionId, page, perPage })
});

export const getApproveSidePanelQuery = (advancingSessionId: number) => ({
  queryKey: ["AdvancingSession.GetSidePanelData", advancingSessionId],
  queryFn: () => window.CoreApi.AdvancingSession.GetSidePanelData(advancingSessionId).then(r => r.data)
});
